<style lang="stylus" scoped>
@import '../cardMap.stylus';

.map-card-cont .map-card-lib:nth-child(even) {
  background: #F8F8F8;
}

.map-card {
  border: 1px solid #ccc;
}

.map-card-cont .map-card-tonnage {
  background: rgba(240, 255, 253, 1) !important;
}
</style>
<template>
  <div class="map-card">
    <div class="map-card-cont" style="top:0;">
      <div
        class="map-card-lib"
        style="margin-top:0;border:0;border-radius:0;"
        v-for="(it,index) in cardItem"
        :key="index"
        :class="index == indexA?'map-card-tonnage':''"
        @click="active(index,it.registProvcode,it.registProvince)"
      >
        <div class="_lib1">{{it.name}}</div>
        <div class="_lib3">{{format(it.value)}}辆</div>
      </div>
      <rightBox v-if="cardItem.length==0"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import allData from '../index.js'
import Cookies from 'js-cookie'
import storage from '@/utils/storage'
export default {
  name: 'mapCard',
  data() {
    return {
      indexA: 0
    }
  },
  props: {
    cardItem: {
      default: () => {
        return allData.list
      },
      type: Array
    }
  },
  computed: {

  },
  mounted() {
    if(Cookies.get('userType')==2){
      let alsit = storage.get('areaList')
      this.active(1,alsit[0].provinceCode,alsit[0].provinceName);
    }
  },
  methods: {
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    active(index,code,name) {
      let that = this
      that.indexA = index
      this.$emit("getDetails",index,code,name)
    }
  }
}
</script>
